import React from 'react';
import IdiomFill from '~/admin/components/questions/IdiomFill.jsx';

export default function IdiomFillDemo() {
  const { buildIdiomsDemo } = require('./demoData');
  const { tokens, gridSize, slots, answers, idioms } = buildIdiomsDemo();

  const handleChange = (report) => {
    console.log('IdiomFill report', report);
    if (report && Array.isArray(report.slotAnswers)) console.log('Slot answers:', report.slotAnswers.join(', '));
  };

  return (
    <div style={{ padding: 18 }}>
      <h3>Idiom Fill — Demo (using payload)</h3>
      <IdiomFill tokens={tokens} gridSize={gridSize} slots={slots} answers={answers} idioms={idioms} onChange={handleChange} showExpected />
    </div>
  );
}
